//LIBRERIE
import React, {useState, useEffect, useRef} from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

//HOOK
import { useGetProperties } from "../../hooks/useGetProperties";
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";


//CONFIG
import appConfig from "../../config/appConfig";
import { AGENCY_ID } from "../../config/appConfig";


//COMPONENTI
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ImmobiliGrid from "../Properties/ImmobiliGrid";
import ImmobiliList from "../Properties/ImmobiliList";


const LastProperties: React.FC = () => {

    const { t } = useTranslation();

    // Ottieni ultimi immobili inseriti
    const { properties, loading, error } = useGetProperties( AGENCY_ID, {
            limit: 6,
            offset: 0,
            withCount: false,
            filters: {
                contract: [],
                type: [],
                provincia: '',
                comune: [],
                frazione: [],
            },
            orderBy: {
                field: '',
                direction: 'desc',
            },
            status: [],
            portal: 56
        }
    );

    // Imposta stile card (grid || list) in base alla configurazione
    const currentView = appConfig.ui.immobiliPage.defaultView;
    const ViewComponent = (currentView === 'list') ? ImmobiliList : ImmobiliGrid;


    // Gestione Responsività Slider
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const [slidesToShow, setSlidesToShow] = useState<number>(window.innerWidth >= 992 ? 3 : window.innerWidth >= 768 ? 2 : 1);
    const [slidesToScroll, setSlidesToScroll] = useState<number>(window.innerWidth >= 992 ? 3 : window.innerWidth >= 768 ? 2 : 1);
    const [arrowsVisible, setArrowsVisible] = useState<boolean>(window.innerWidth >= 1200);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
        setSlidesToShow(window.innerWidth >= 992 ? 3 : window.innerWidth >= 768 ? 2 : 1);
        setSlidesToScroll(window.innerWidth >= 992 ? 3 : window.innerWidth >= 768 ? 2 : 1);
        setArrowsVisible(window.innerWidth >= 1200);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [windowWidth]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: arrowsVisible
    };

    // Animazione Ingresso Immobili
    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLDivElement | null>(null);
    const allLinkRefs: React.RefObject<HTMLDivElement | null>[] = [ref1];

    useInViewAnimation({ animationElementsRef: allLinkRefs, animationClass: 'fade-in-left', pageReady: pageReady });

    // ---- Gestione Stati Iniziali ----
    if (loading) return <LoadingIndicator />;

    if (error) {
        console.error("Errore caricamento Immobili:", error);
        return <div className="alert alert-warning">{t('common.loadingError', 'Errore caricamento dati.')}</div>;
    }

    if (!properties || properties.length === 0) {
        return <div className="text-center p-5">{t('propertyList.notFound.title')}</div>;
    }

    return(
        <section id="last-properties" className="space-pb">
            <div className="container-fluid w-special">
                <h2 className="mb-4 text-center">{t('homePage.lastPropertiesAdd.title')}</h2>
                <div className="slider-container" ref={allLinkRefs[0]}>
                    <Slider {...settings} >
                        {properties.map(property => (
                        <div key={property.id} className="px-2">
                            <ViewComponent
                                properties={[property]}
                                loading={loading}
                                error={null}
                                basePath="immobile"
                                labelSold={false}
                                isSliderItem={true}
                            />
                        </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
};
export default LastProperties;
                        